// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(ElementUI)
axios.defaults.baseURL = "https://howardlee.cn/arena/aapi"
// axios.defaults.baseURL = "http://0.0.0.0:5000/"
// axios.defaults.baseURL = "http://47.93.81.163:80/"
// axios.defaults.baseURL = "http://192.168.142.129:5000/"  // ORCA 虚拟机的地址
// axios.defaults.baseURL = "http://192.168.31.183:5000/"  // Ubuntu 18
// axios.defaults.baseURL = "http://82.157.149.11:6003/"
Vue.prototype.$axios = axios

/**
 * 在绘制树节点时，根据需要对不同类型的节点设置不同颜色
 * @param {Object} data table 中每一行对应的 tree 结构
 * @param {Boolean} isDiffColor 是否设置不同颜色
 */
Vue.prototype.setDiffColor = function (data, isDiffColor) {
  // console.log("调用设置颜色函数")
  if (isDiffColor) {
    let tableDict = data.TABLE;
    let scanDict = data.SCAN;
    let joinDict = data.JOIN;
    for (let i=0;i<data.nodes.length;i++){
      let id = data.nodes[i].id
      let name = data.nodes[i].text;
      if(id in tableDict){  // 设置 TABLE 标签的节点的颜色
        data.nodes[i].color = "#f4f4f5";
      } else if (id in scanDict) {  // 设置 SCAN 标签的节点的颜色
        data.nodes[i].color = "#c6e2ff";
        // 根据具体的方法设置字体的颜色
        if (name.search("TableScan") !== -1){
          // do nothing
        } else if (name.search("IndexScan") !== -1) {
          data.nodes[i].fontColor = "#F56C6C";
        } else if (name.search("IndexOnlyScan") !== -1) {
          data.nodes[i].fontColor = "#E6A23C";
        }
      } else if (id in joinDict) {  // 设置 JOIN 标签的节点的颜色
        data.nodes[i].color = "#f8e3c5";
        // 根据具体的方法设置字体的颜色
        if (name.search("HashJoin") !== -1){
          // do nothing
        } else if (name.search("IndexNLJoin") !== -1) {
          data.nodes[i].fontColor = "#409EFF";
        }
      } else {
        data.nodes[i].color = "#c8c9cc";
      }
    }
  } else if (data.rootId !== 1){  // rootId 为 1 说明是需要隐藏的数据
    // 删除 color 属性，使用默认的颜色
    for (let i=0;i<data.nodes.length;i++) {
      delete data.nodes[i].color;
      delete data.nodes[i].fontColor;
    }
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
